import React, { useState, useEffect } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import "./../Franchise.css";
import { deleteInvoicePayment } from "../../../Helpers/apiCalls/Sales/franchiseInvoice";
import { deleteFranchiseePayment } from "../../../Helpers/apiCalls/Franchise/FranchiseApi";
import { searchFranchiseSaleBillingPayment } from "../../../Helpers/apiCalls/Franchise/FranchiseSaleBillingApi";
import { getAllFranchisee, searchFranchiseeSalesPayment } from "../../../Helpers/apiCalls/franchiseeApi";
import {
    getAllReceivables,
    getReceivable,
    searchReceivables,
    searchFranchisee,
    getAllReceivablesDate,
    getAllPayments,
    searchPaymentsDate,
    markAsDone
} from "../../../Helpers/apiCalls/Franchise/ReceivablesApi";
import ViewModal from "../../../Components/Modals/ViewModal";
import MarkAsDoneModal from "./MarkAsDoneModal";
import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi";
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";

export default function MultiplePaymentsView() {
    const { id, type } = useParams();
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [isClicked, setIsClicked] = useState(false);
    const today = Moment().format("MM/DD/YYYY")

    const excelHeaders = [
        { label: "DATE PAID", key: "payment_date" },
        { label: "FRANCHISEE", key: "franchisee_name" },
        { label: "BRANCH", key: "branch_name" },
        { label: "PAID AMT", key: "paid_amount" },
        { label: "PMT FOR", key: "payment_for" },
        { label: "REMARKS", key: "remarks" },
        { label: "DEP DATE", key: "deposit_date" },
        { label: "DEP TO", key: "deposit_to" },
        { label: "CHK DATE", key: "check_date" },
        { label: "REF/CHK", key: "check_no" },
        { label: "PMT MODE", key: "payment_mode" },
    ];
    
    const [franchisees, setFranchisees] = useState([]);
    const [franchiseesData, setFranchiseesData] = useState([]);
    const [receivableData, setReceivableData] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [inactive, setInactive] = useState(true);

    const [showLoader, setShowLoader] = useState(false);

    async function fetchAllPayments() {
        setShowLoader(true);
        setReceivableData([]);
        if(type === "salesinvoice") {
            const response = await searchFranchiseeSalesPayment(id);
            
            if (response.data) {
                var receivables = response.data.data?.map((data, index) => {
                    var receive = data;
                    receive.id_no = data.id;
                    receive.id = data.index;
                    receive.branch_name = data.franchisee_sale[0]?.buyer_branch_name;
                    receive.added_on = Moment(data.added_on).format("MM-DD-YYYY");
                    receive.payment_date = data.payment_date ? Moment(data.payment_date).format("MM-DD-YYYY") : "N/A";
                    receive.deposit_date = data.deposit_date ? Moment(data.deposit_date).format("MM-DD-YYYY") : "N/A";
                    receive.amount = numberFormat(data.amount);
                    receive.paid_amount = numberFormat(data.paid_amount);
                    receive.check_no = data.check_no? data.check_no : data.ref_no? data.ref_no : "N/A";
                    receive.check_date = data.payment_mode === "cash" ? "N/A" : 
                        (data.check_date !== null && data.check_date !== "0000-00-00") ? Moment(data.check_date).format("MM-DD-YYYY") : "N/A";
                    return receive;
                });
                
                var Amount = response.data.summary? response.data.summary.total_amount : "0";
                setTotalAmount(Amount);
    
                setReceivableData(receivables);
            }
        } else {
            const response = await searchFranchiseSaleBillingPayment(id);
            
            if (response.data) {
                var receivables = response.data.data?.map((data, index) => {
                    var receive = data;
                    receive.id_no = data.id;
                    receive.id = data.index;
                    receive.branch_name = data.branch_name;
                    receive.franchisee_name = data.fs_billing[0]?.franchisee_name;
                    receive.added_on = Moment(data.added_on).format("MM-DD-YYYY");
                    receive.payment_date = data.payment_date ? Moment(data.payment_date).format("MM-DD-YYYY") : "N/A";
                    receive.deposit_date = data.deposit_date ? Moment(data.deposit_date).format("MM-DD-YYYY") : "N/A";
                    receive.amount = numberFormat(data.amount);
                    receive.paid_amount = numberFormat(data.paid_amount);
                    receive.check_no = data.check_no? data.check_no : data.ref_no? data.ref_no : "N/A";
                    receive.check_date = data.payment_mode === "cash" ? "N/A" : 
                        (data.check_date !== null && data.check_date !== "0000-00-00") ? Moment(data.check_date).format("MM-DD-YYYY") : "N/A";
                    return receive;
                });
                
                var Amount = response.data.summary? response.data.summary.total_paid_amount : "0";
                setTotalAmount(Amount);
    
                setReceivableData(receivables);
            }
        }
        setShowLoader(false);
    }

    function PrintBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handlePrint(row)}
            >
                View
            </button>
        );
    }
    
    function handlePrint(row) {
        if(type === "salesinvoice") {
            window.open("/salesinvoice/print/" + row.franchisee_sale_id);
        } else if(type === "franchisebilling") {
            window.open("/franchisebilling/view/" + row.fs_billing_id);
        }
    }

    function CheckBox(row) {
        return (
            <Form.Check
                type="checkbox"
                name="is_done"
                value="1"
                disabled
                checked={row.is_done === "1" ? true : false}
            />
        );
    }

    React.useEffect(() => {
        fetchAllPayments();
    }, []);


    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"FRANCHISE"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={6}>
                        <h1 className="page-title"> VIEW MULTIPLE PAYMENTS </h1>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col xs={6}>
                        <h5 className="page-subtitle"> Total Deposited Amount: {numberFormat(totalAmount)}</h5>
                    </Col>
                </Row>
                {/* <Row>
                    <Col className="d-flex justify-content-end mb-4">
                        <div className="justify-content-center align-items-center ">
                            <CSVLink
                                className="button-primary px-3 py-3 justify-content-center align-items-center download-csv"
                                data={receivableData}
                                headers={excelHeaders}
                                target="_blank"
                                filename={`${getTodayDateISO()} - Payments`}
                            >
                                <span className="me-2">
                                    <img
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                Download Excel
                            </CSVLink>
                        </div>
                    </Col>
                </Row> */}

                <div className="tab-content">

                    <div className="below">
                        {/* table */}
                        <Table
                            tableHeaders={[
                                "-",
                                // "*",
                                "DATE PAID",
                                "FRANCHISEE",
                                "BRANCH",
                                "PAID AMT",
                                "PMT FOR",
                                "REMARKS",
                                "DEP DATE",
                                // "DEP TO",
                                "CHK DATE",
                                "REF/CHK",
                                "PMT MODE",
                            ]}
                            headerSelector={[
                                "-",
                                // "*",
                                "payment_date",
                                "franchisee_name",
                                "branch_name",
                                "paid_amount",
                                "payment_for",
                                "remarks",
                                "deposit_date",
                                // "deposit_to",
                                "check_date",
                                "check_no",
                                "payment_type",
                            ]}
                            tableData={receivableData}
                            ViewBtn={(row) => PrintBtn(row)}
                            showLoader={showLoader}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                <div className="d-flex justify-content-end pt-2 mb-3">
                    <button
                        name="action"
                        className="ms-2 button-primary justify-content-center align-items-center close-btn"
                        onClick={() => navigate("/payments")}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}
